import { render } from "./DragButton.vue?vue&type=template&id=fa57119a&scoped=true"
import script from "./DragButton.vue?vue&type=script&lang=js"
export * from "./DragButton.vue?vue&type=script&lang=js"

import "./DragButton.vue?vue&type=style&index=0&id=fa57119a&lang=scss&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa57119a"]])

export default __exports__